import { FC, useCallback } from "react";

/**
 * Download button for a deposit's multisigned refund tx. Produces a
 * cardano-cli TextEnvelope file so the refund can be submitted with standard
 * tooling if the user ever needs to exercise it themselves.
 */
export const RefundDownloadButton: FC<{
  hash: string;
  cbor: string;
  className?: string;
}> = ({ hash, cbor, className }) => {
  const handleDownload = useCallback(() => {
    const envelope = {
      type: "Tx ConwayEra",
      description: "Deposit refund transaction",
      cborHex: cbor,
    };
    const blob = new Blob([JSON.stringify(envelope, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `refund-${hash}.tx.json`;
    a.click();
    URL.revokeObjectURL(url);
  }, [hash, cbor]);

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleDownload();
      }}
      className={
        className ??
        "text-sr-pink-muted hover:text-sr-pink-light transition-colors"
      }
      title="Download refund transaction"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
    </button>
  );
};
